module.exports = __webpack_public_path__ + "img/leadSpamByAdvertiser.96762520.svg";